'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//@flow

var px2EmSync = function px2EmSync(px, options) {
  if (typeof px !== 'number') {
    throw new TypeError('`px` should be a number');
  }

  var _base$format$options = _extends({
    base: 16,
    format: null
  }, options),
      base = _base$format$options.base,
      format = _base$format$options.format;

  if (typeof base !== 'number' || base < 0) {
    throw new TypeError('`base` should be a number greater than zero');
  }

  var em = Math.round(px / base * 1000) / 1000;

  if (format == null) {
    return em;
  }

  return '' + em + format;
};

exports.default = px2EmSync;